import { TEXT_SIZE } from '../constants/limits';
import { stateKeys } from '../constants/stateKeys';

export const selectEditComment = (state) => {
  return state[stateKeys.editComment];
};

export const selectEditCommentId = (state) => {
  return state[stateKeys.editComment]?.id;
};

export const selectHasEditComment = (state) => {
  return Boolean(state[stateKeys.editComment]);
};

export const selectCommentText = (state) => {
  return state[stateKeys.text];
};

export const selectIsTextValid = (state) => {
  const text = state[stateKeys.text]?.trim() ?? '';
  return text.length > 0 && text.length <= TEXT_SIZE;
};

export const selectTextLimitExceeded = (state) => {
  const text = state[stateKeys.text]?.trim() ?? '';
  return text.length > TEXT_SIZE;
};

export const selectTextSize = (state) => {
  const text = state[stateKeys.text]?.trim() ?? '';
  return text.length;
};

export const selectImages = (state) => {
  return state[stateKeys.images];
};

export const selectFiles = (state) => {
  return state[stateKeys.files];
};

export const selectVisible = (state) => {
  return state[stateKeys.visible];
};

export const selectHasImages = (state) => {
  return state[stateKeys.images]?.length > 0;
};

export const selectHasFiles = (state) => {
  return state[stateKeys.files]?.length > 0;
};
